import React, {useContext, useEffect, useState} from "react";
// @ts-ignore
import {Link} from "react-router-dom";
import Constants from "../../../data/Constants";
import {GlobalDataContext} from "../../../contexts/GlobalDataContext";
import {SkeletonLine} from "../../SkeletonLoader/SkeletonLoaders";
import withLoadingAnimation from "../../AnimationWrapper/AnimationWrapper";
import '../../AnimationWrapper/WrapperAnimations.css'
import './YearReportStyle.css';
import Colors from "../../../assets/colors/Colors";
import {RankingsAndLevelsContext} from "../../../contexts/RankingsAndLevelsContext";
import {useTranslation} from "react-i18next";

const MIN_REPORT_YEAR = 2008;

const YearList: React.FC<{years: string[]}> = ({years}) => {
    const calcOpacity: any = (index: number) => {
        const minOpacity = 0.05;
        let opacity = 1 - index * minOpacity;
        return opacity >= 0.2 ? opacity : 0.2;
    };

    //@ts-ignore
    const {isLife} = useContext(RankingsAndLevelsContext);
    const color = isLife ? Colors.fontWhite : Colors.fontGray;
    return (
        <React.Fragment>
            { years.map((year, index) => (
                <div
                    key={index}
                    style={{marginBottom: 20, opacity: calcOpacity(index)}}
                >
                    <Link
                        style={{fontSize: 64, color: color, fontFamily: 'Mapfre-Medium', textShadow: '#00000029 0 3px 6px'}}
                        to={Constants.routes.rankingsTiers.replace(':yearCode', year)}
                    >
                        { year }
                    </Link>
                </div>)
            )}
        </React.Fragment>
    )
};

const YearReportComponent: React.FC = () => {
    // @ts-ignore
    const { reportsAvailables, allDataLoaded } = useContext(GlobalDataContext);
    const [years, setYears] = useState<string[]>([]);
    const { t } = useTranslation();

    useEffect(() => {
        if(allDataLoaded){
            setYears(Object.keys(reportsAvailables).filter(elem => Number(elem) > MIN_REPORT_YEAR).sort().reverse())
        }
    }, [allDataLoaded]);

    return (
        <div className='yearReportWrapper'>
            <div className='reportFont'>
                { t('rankingsAndLevels.reports') }
            </div>
            <div className='yearListWrapper'>
                {
                    withLoadingAnimation(
                        <YearList years={years} />,
                        <SkeletonLine count={10} width={200} />,
                        allDataLoaded
                    )
                }
            </div>
        </div>
    )
};

export default YearReportComponent;
